
import { RoleType } from "us.collection.case/components/OtherParty/Constants";;

export const filterOtherPartiesForCreditorManagement = (
  otherParties: any
): Array<any> => {
  try {
    return otherParties?.data?.filter(
      (other: any) => other?.roleType?.toLowerCase() === RoleType.CONTACT_PERSON
    );
  } catch (error) {
    console.error(error);
    return [];
  }
};
 type CommunicationMethodData = {
   communicationEmail?: boolean;
   communicationSms?: boolean;
   communicationLetter?: boolean;
 };

 /**
  * @description - Build communication methods array from provided data
  * @param {ICommunicationMethodData} data - object containing communication flags
  * @returns - return array of available communication method names
  */
 export const buildCommunicationMethod = (
   data: CommunicationMethodData,
 ): string[] => {
   try {
     const methods: string[] = [];
     if (data?.communicationEmail) {
       methods.push("Email");
     }
     if (data?.communicationSms) {
       methods.push("SMS");
     }
     if (data?.communicationLetter) {
       methods.push("Letter");
     }
     return methods;
   } catch (error) {
     console.error(error);
     return [];
   }
 };